module.exports = __webpack_public_path__ + "static/ipo-976106bb5649d231054140b0451c274e.png";